import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Util, WindowReference, XmStore, XmStoreUtil } from 'core/services';
import { CmsCore } from 'store/cms/models';

@Component({
    selector: 'xm-sub-nav',
    styleUrls: ['./sub.scss'],
    templateUrl: './sub.html',
    standalone: false
})
export class XmSubNavComponent implements OnInit, OnDestroy {
    public pageData: CmsNavMenuItems[] = [];

    private subscriptions: Subscription[] = [];
    private xmStore: XmStore;

    constructor(xmStore: XmStore, windowRef: WindowReference) {
        Object.assign(this, { xmStore, windowRef });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsCore>(CmsCore), (result: CmsCore) => {
            this.pageData = result.nav.subNav;
        }));
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
